import { inject } from "aurelia";
import { I18N, Signals } from "@aurelia/i18n";
import { formatDate, toDate } from "../../common/dates";

@inject(I18N)
export class DateSmallValueConverter {
  signals = [Signals.I18N_SIGNAL];

  constructor(i18n) {
    this.i18n = i18n;
  }

  toView(value) {
    if (value == null) return null;
    const date = toDate(value);
    const format = date.getFullYear() < new Date().getFullYear() ? "D MMM YYYY" : "D MMM";
    return formatDate(date, format, this.i18n.getLocale());
  }
}
